import React, { Fragment } from 'react';
import { Container, Button } from 'react-bootstrap';
import Header from '../../../components/header';
import Head from '../../../components/head';
import Footer from '../../../components/footer';
import ListAtaCons from '../../../components/educacao/documentos/atasalimentacao';


function ListAtaConsScreen() {
    return (
        <Fragment>
            <Head titulo="Atas de reuniões do Conselho Municipal de Alimentação em Macuco" />
            <Header />
            <Container>
               <ListAtaCons /><br/><br/>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListAtaConsScreen;